import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { SendByteScannedTransaction } from "@lib/types";
import { ApiParams, PaginationType } from "@lib/types/Api";
import {
  SendBytePaymentRequest,
  SendByteWallet,
  SendByteWalletAddress,
} from "@lib/types/SendByte";

export const apiAddSendByteWallet = async (data: SendByteWallet) => {
  return API.post<SendByteWallet>(`/send-byte-wallet`, data);
};

export const apiDeleteSendByteWallet = async (data: SendByteWallet) => {
  return API.delete<null>(`/send-byte-wallet/${data.id}`);
};

export const apiUpdateSendByteWallet = async (data: SendByteWallet) => {
  const { id, ...rest } = data;
  return API.patch<SendByteWallet>(`/send-byte-wallet/${id}`, rest);
};

export const apiGetSendByteWallets = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/send-byte-wallet` });
  return API.get<PaginationType<SendByteWallet>>(url);
};

export const apiAddMultipleSendByteWalletAddress = async (
  data: SendByteWalletAddress[],
) => {
  return API.post<SendByteWalletAddress[]>(
    `/send-byte-wallet-address/bulk`,
    data,
  );
};

export const apiAddSendByteWalletAddress = async (
  data: SendByteWalletAddress,
) => {
  return API.post<SendByteWalletAddress>(`/send-byte-wallet-address`, data);
};

export const apiDeleteSendByteWalletAddress = async (
  data: SendByteWalletAddress,
) => {
  return API.delete<null>(`/send-byte-wallet-address/${data.id}`);
};

export const apiUpdateSendByteWalletAddress = async (
  data: Partial<SendByteWalletAddress>,
) => {
  const { id, ...rest } = data;
  return API.patch<SendByteWalletAddress>(
    `/send-byte-wallet-address/${id}`,
    rest,
  );
};

export const apiGetSendByteWalletAddress = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/send-byte-wallet-address` });
  return API.get<PaginationType<SendByteWalletAddress>>(url);
};

// #
// ####### customer-lead-scanned-transaction #######
export const apiAddScanSendByteWalletAddress = async (
  data: SendByteWalletAddress,
) => {
  return API.post<SendByteWalletAddress>(
    `/customer-user-scanned-transaction/scan/history/${data.id}`,
  );
};

export const apiGetCustomerLeadScannedTransaction = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({
    params,
    url: `/customer-user-scanned-transaction`,
  });
  return API.get<PaginationType<SendByteScannedTransaction>>(url);
};

// #
// ####### customer-lead-billing-history #######
export const apiGetCustomerLeadBillingHistories = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({
    params,
    url: `/customer-user-transaction-history`,
  });
  return API.get<PaginationType<SendBytePaymentRequest>>(url);
};

export const apiAddCustomerLeadBillingHistory = async (
  data: Partial<SendBytePaymentRequest>,
) => {
  return API.post<Partial<SendBytePaymentRequest>>(
    `/customer-user-transaction-history`,
    data,
  );
};

export const apiDeleteCustomerLeadBillingHistory = async (
  data: SendBytePaymentRequest,
) => {
  return API.delete<null>(`/customer-user-transaction-history/${data.id}`);
};

export const apiUpdateCustomerLeadBillingHistory = async (
  data: Partial<SendBytePaymentRequest>,
) => {
  return API.patch<Partial<SendBytePaymentRequest>>(
    `/customer-user-transaction-history/${data.id}`,
    data,
  );
};
